import { LOCAL_STORAGE_KEYS, useAuth } from "@iliotech/data-wire";
import { PropsWithChildren, useEffect, useState } from "react";
import { FullScreenCssSpinner } from "../../FullScreenCssSpinner/FullScreenCssSpinner";
import { useQueryClient } from "react-query";
import { Auth } from "aws-amplify";

const REQUIRED_EMAIL = "ovidiu+2025@illio.com";

export const WhatIfAccountWrapper = ({ children }: PropsWithChildren<any>) => {
  const [userEmail, setUserEmail] = useState<string>("");
  const [externalAccountId, setExternalAccountId] = useState<string>("");

  const isWhatIfAccount = userEmail === REQUIRED_EMAIL;
  const hasEmail = !!userEmail;

  Auth.currentAuthenticatedUser().then((user) => {
    console.log({ user });
    setUserEmail(user.attributes?.email!);
  });
  const queryClient = useQueryClient();
  const switchAccount = () => {
    queryClient.clear();
    console.log("LOGGING_OUT");
    Auth.signOut().then(() => {
      console.log("LOGGED_OUT");
      window.sessionStorage.clear();
      localStorage.removeItem(LOCAL_STORAGE_KEYS.ILLIO_SELECTED_ACCOUNT);
      console.log("LOGGING_IN");
      Auth.signIn({
        username: "ovidiu+2025@illio.com",
        password: "IblpTest@123",
      }).then((user) => {
        console.log({ user });
        setUserEmail(REQUIRED_EMAIL);
        console.log("LOGGED_IN");
      });
    });
  };

  const login = () => {
    Auth.signIn({
      username: "ovidiu+2025@illio.com",
      password: "IblpTest@123",
    }).then((user) => {
      console.log({ user });
      setUserEmail(REQUIRED_EMAIL);
      console.log("LOGGED_IN");
    });
  };

  useEffect(() => {
    if (!isWhatIfAccount) {
      if (hasEmail) {
        console.log("SWITCHING_ACCOUNT");
        switchAccount();
      } else {
        console.log("NO_EMAIL");
        login();
      }
    }
  }, [isWhatIfAccount, hasEmail]);

  if (!isWhatIfAccount) {
    return <FullScreenCssSpinner />;
  }

  return <>{children}</>;
};
